var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "cover-wrapper",
        { "in-progress": _vm.isInProgressView, mobile: _vm.isMobile(_vm.$mq) }
      ]
    },
    [
      _vm.isMobile(_vm.$mq)
        ? _c(
            "ScrollableTopBar",
            {
              attrs: {
                "target-element-id": this.isInProgressView
                  ? undefined
                  : "course-cover-title"
              }
            },
            [
              _c(
                "div",
                { staticClass: "top-bar" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "back-button",
                      attrs: { to: { name: "explorations_menu" } }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "/site_media/version-0/images/course-page/chevron-left.svg",
                          alt: "Back arrow"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sliding-bar-content" },
                    [
                      _c("h4", { staticClass: "course-name" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.course.name) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "transition",
                        { attrs: { name: "fade-fast", mode: "out-in" } },
                        [
                          _vm.coverBarIsExpanded
                            ? _c(
                                "div",
                                { staticClass: "expandable" },
                                [
                                  _vm.learningPath
                                    ? _c("LearningPathPill", {
                                        staticClass: "llp-pill",
                                        attrs: {
                                          learningPath: _vm.learningPath
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("CoverDescriptions", {
                                    attrs: {
                                      course: _vm.course,
                                      lessons: _vm.lessons,
                                      "has-practice": _vm.hasPractice
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.isInProgressView
                                          ? {
                                              key: "sub-description",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "progress-bar-container"
                                                    },
                                                    [
                                                      _c("ProgressBar", {
                                                        attrs: {
                                                          "completion-percentage":
                                                            _vm.completionPercentage
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.course.course_map
                                    ? _c("ModalCourseMap", {
                                        attrs: {
                                          prerequisites:
                                            _vm.course.course_map.prerequisites,
                                          nextSteps:
                                            _vm.course.course_map.next_steps
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isInProgressView && !_vm.coverBarIsExpanded
                        ? _c(
                            "div",
                            { staticClass: "progress-bar-container" },
                            [
                              _c("ProgressBar", {
                                attrs: {
                                  "completion-percentage":
                                    _vm.completionPercentage
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isInProgressView
                    ? _c("img", {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId: "clicked_course_info",
                              axType: "button",
                              axExtra: { course_id: _vm.course.course_id }
                            },
                            expression:
                              "{\n          axId: 'clicked_course_info',\n          axType: 'button',\n          axExtra: { course_id: course.course_id },\n        }",
                            arg: "click"
                          }
                        ],
                        staticClass: "info-button",
                        attrs: {
                          src: _vm.coverBarIsExpanded
                            ? "/site_media/version-0/images/course-page/close.svg"
                            : "/site_media/version-0/images/course-page/info.svg",
                          alt: _vm.coverBarIsExpanded
                            ? "View less"
                            : "View more"
                        },
                        on: { click: _vm.toggleExpandedCoverBar }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile(_vm.$mq) || !_vm.isInProgressView
        ? _c(
            "div",
            { staticClass: "cover" },
            [
              _c(
                "div",
                { staticClass: "title-container" },
                [
                  _c(
                    "div",
                    { staticClass: "image" },
                    [
                      _c("BriocheBackgroundImage", {
                        attrs: { src: _vm.course.intro_image_url, width: 78 }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.learningPath
                    ? _c("LearningPathPill", {
                        staticClass: "llp-pill",
                        attrs: { learningPath: _vm.learningPath }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      ref: "courseName",
                      staticClass: "name",
                      attrs: { id: "course-cover-title" }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.course.name) + "\n        "
                      ),
                      !_vm.isMobile(_vm.$mq) && !_vm.hideInfoIcon
                        ? _c("img", {
                            directives: [
                              {
                                name: "track",
                                rawName: "v-track:click",
                                value: {
                                  axId: "clicked_course_info",
                                  axType: "button",
                                  axExtra: { course_id: _vm.course.course_id }
                                },
                                expression:
                                  "{\n            axId: 'clicked_course_info',\n            axType: 'button',\n            axExtra: { course_id: course.course_id },\n          }",
                                arg: "click"
                              }
                            ],
                            staticClass: "info-button",
                            attrs: {
                              src:
                                "/site_media/version-0/images/course-page/info.svg",
                              alt: "View more"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("view-more")
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isMobile(_vm.$mq) && _vm.isInProgressView
                ? _c(
                    "div",
                    { staticClass: "progress-bar-container" },
                    [
                      _c("ProgressBar", {
                        attrs: {
                          "completion-percentage": _vm.completionPercentage
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("CoverDescriptions", {
                attrs: {
                  course: _vm.course,
                  lessons: _vm.lessons,
                  "has-practice": _vm.hasPractice
                }
              }),
              _vm._v(" "),
              _vm.adminMenu && !_vm.isMobile(_vm.$mq)
                ? _c("AdminMenu", {
                    staticClass: "admin-menu",
                    attrs: {
                      items: _vm.adminMenu.items,
                      badges: _vm.adminMenu.badges,
                      orientation: ["top", "left"]
                    },
                    on: {
                      "reset-course-state": _vm.handleResetCourseState,
                      "bulk-reset-course-state": _vm.handleBulkResetCourseState
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.coverBarIsExpanded
        ? _c("div", {
            ref: "closableOverlay",
            staticClass: "closable-overlay",
            on: { click: _vm.toggleExpandedCoverBar }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }